export default __webpack_public_path__ + "static/workflow-bg-6f41ca8196931650aba1c3ce69a6c0bc.webp";